module.exports = __webpack_public_path__ + "static/vr-1-1-eef2ca58e3db277fefd30643c831f30a.jpeg";